var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDexscreener(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 60,
    viewBox: "0 0 50 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5190_2765)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1224 21.3732C31.9432 20.458 34.2601 19.1108 36.5797 17.265C37.0688 18.2888 37.1224 19.1822 36.8704 19.9036C36.6918 20.412 36.3553 20.8542 35.9129 21.206C35.4337 21.5862 34.8353 21.863 34.1738 22.0126C32.9186 22.2976 31.4531 22.1312 30.1224 21.3732ZM30.4381 30.7504L32.8484 32.1538C27.9269 34.9342 26.589 40.097 24.9998 45.1256C23.4107 40.097 22.0726 34.9342 17.1513 32.1538L19.5617 30.7504C19.7948 30.6616 19.9941 30.5006 20.131 30.2906C20.2679 30.0807 20.3353 29.8324 20.3236 29.5814C20.1027 24.872 21.3642 22.7894 23.0658 21.4818C23.6762 21.0134 24.3424 20.7782 24.9998 20.7782C25.6571 20.7782 26.3234 21.0134 26.9339 21.4818C28.6355 22.7894 29.897 24.872 29.6762 29.5814C29.6645 29.8324 29.7319 30.0807 29.8687 30.2906C30.0056 30.5006 30.2049 30.6616 30.4381 30.7504ZM24.9998 0C27.7859 0.0754 30.5789 0.6206 33.0029 1.6812C34.6815 2.4166 36.2478 3.388 37.666 4.5496C38.3065 5.074 38.8339 5.5806 39.4148 6.1638C40.9817 6.2184 43.2716 4.4638 44.3347 2.822C42.5051 8.868 34.1563 16.0078 28.3764 18.7398C28.374 18.7388 28.3724 18.7374 28.3706 18.7362C27.3333 17.9378 26.1666 17.5386 24.9998 17.5386C23.8329 17.5386 22.6664 17.9378 21.6291 18.7362C21.6273 18.7372 21.6258 18.739 21.6234 18.7398C15.8432 16.0078 7.4946 8.868 5.66504 2.822C6.72794 4.4638 9.01782 6.2184 10.5847 6.1638C11.1658 5.5808 11.6932 5.074 12.3335 4.5496C13.7517 3.388 15.318 2.4166 16.9966 1.6812C19.4208 0.6206 22.2139 0.0754 24.9998 0ZM19.8771 21.3732C18.0565 20.458 15.7394 19.1108 13.42 17.265C12.9309 18.2888 12.8773 19.1822 13.1291 19.9036C13.3079 20.412 13.6444 20.8542 14.0867 21.206C14.566 21.5862 15.1644 21.863 15.826 22.0126C17.0811 22.2976 18.5464 22.1312 19.8771 21.3732Z",
    fill: "url(#paint0_linear_5190_2765)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1204 15.0032C40.3974 13.7042 41.5226 12.2664 42.4274 10.9834L42.8869 11.8552C44.3663 14.8386 45.1349 17.81 45.1349 21.154L45.1317 26.4604L45.1595 29.2112C45.2667 35.9644 46.7163 42.797 50 49.0498L43.1296 43.4654L38.2683 51.4172L33.1611 46.571L25 59.9208L16.8389 46.5712L11.7319 51.4174L6.87063 43.4656L0 49.05C3.28373 42.7972 4.73333 35.9646 4.84067 29.2114L4.86845 26.4606L4.86528 21.1542C4.86528 17.81 5.63373 14.8386 7.11349 11.8554L7.57282 10.9836C8.47758 12.2666 9.60258 13.7042 10.8798 15.0034L10.481 15.8384C9.70615 17.4602 9.4496 19.2736 10.0532 20.9982C10.4423 22.109 11.1524 23.0616 12.0679 23.7888C12.9567 24.495 14.0087 24.971 15.1101 25.221C15.8276 25.3838 16.5585 25.4508 17.2847 25.428C17.1153 26.3962 17.0413 27.4004 17.0365 28.4236L10.5556 32.1968L15.5567 35.0226C15.9565 35.2485 16.337 35.5073 16.6944 35.7964C20.8177 39.528 23.2966 50.5674 25.0002 55.9596C26.704 50.5674 29.1827 39.528 33.3062 35.7964C33.6636 35.5073 34.0441 35.2485 34.4439 35.0226L39.445 32.1968L32.9639 28.4236C32.9591 27.4004 32.8851 26.3962 32.7157 25.428C33.4419 25.4508 34.1728 25.3838 34.8903 25.221C35.9917 24.971 37.0438 24.495 37.9325 23.7888C38.8478 23.0616 39.5581 22.109 39.947 20.9982C40.5508 19.2736 40.294 17.4604 39.5194 15.8384L39.1206 15.0034L39.1204 15.0032Z",
    fill: "url(#paint1_linear_5190_2765)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5190_2765",
    x1: 14.124,
    y1: -0.00000168369,
    x2: 41.6369,
    y2: 15.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB10D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5190_2765",
    x1: 10.9375,
    y1: 10.9834,
    x2: 43.2619,
    y2: 32.5516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB10D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5190_2765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDexscreener);
export default __webpack_public_path__ + "static/media/dexscreener.39a922974236d67f36347c12058dd719.svg";
export { ForwardRef as ReactComponent };